module.exports = __webpack_public_path__ + "static/media/file_pdf_light.96b891f6.svg";